<template>
    <div class="tab_wrap">
        <div class="tab_bar">
            <span v-for="(n,i) in tabNames" v-bind:key="i" :data-i="i"
            :class="{'selected':i==selected_tab, 'done':n.done}"
            @click="clickTab" @keydown="clickTab" tabindex="0">{{n.name}}</span>
            <i style="width: 2em">&nbsp;</i>
        </div>
        <div v-for="(n,i) in tabNames" v-bind:key="i" class="tab" :class="{'selected':i==selected_tab}"><slot :name="n.name"></slot></div>
    </div>
</template>

<script>
//import {EventBus} from '../event-bus'
export default {
    data: function() {
        return {
            selected_tab: 0,
            tabNames: Array,
            incompleteTabs: [],
            rec: {
                secondarystudent:"",
                schoolyear:"",
                myschool:"",
                biology:false,
                chemistry:false,
                physics:false,
                maths:false,
                mathsSpecify:"",
                english:false,
                englishSpecify:"",
                interested:"",
                descendant:"",
                firstnames:"",
                lastname:"",
                gender:"",
                dob:"",
                homephone:"",
                mobilephone:"",
                address:"",
                suburb:"",
                city:"",
                postcode:"",
                email:"",
                instagram:"",
                tiktok:"",
                Samoan:false,
                SamoanVillages:"",
                Niuean:false,
                NiueanVillages:"",
                Tongan:false,
                TonganVillages:"",
                CookIsland:false,
                CookIslandVillages:"",
                iTaukeiFijian:false,
                iTaukeiFijianVillages:"",
                Rotuman:false,
                RotumanVillages:"",
                Tuvaluan:false,
                TuvaluanVillages:"",
                Tokelauan:false,
                TokelauanVillages:"",
                Kiribati:false,
                KiribatiVillages:"",
                OtherPacificethnicity:false,
                OtherPacificethnicityVillages:"",
                Māori:false,
                NZEuropean:false,
                Chinese:false,
                Indian:false,
                MELAA:false,
                EthnicityOther:false,
                EthnicityOtherSpecify:"",
                certifiername:"",
                certifieraddress:"",
                certifierphone:"",
                certifieremail:"",
                certElder:false,
                certChurch:false,
                certOther:false,
                certOtherSpecify:"",
                PathwayMedicine:false,
                PathwayPharmacy:false,
                PathwayNursing:false,
                PathwayHealthSciences:false,
                PathwayOptometry:false,
                PathwayMedicalImaging:false,
                PathwayUnsure:false,
                PathwayOther:false,
                PathwayOtherSpecify:false,
                HearAboutSchool:false,
                HearAboutFamilyFriends:false,
                HearAboutSocialMedia:false,
                HearAboutExpo:false,
                HearAboutOther:false,
                HearAboutOtherSpecify:"",
                Ancestor:{
                      m:{name:"",p:false,o:false},
                      f:{name:"",p:false,o:false},
                     mm:{name:"",p:false,o:false},
                     mf:{name:"",p:false,o:false},
                     fm:{name:"",p:false,o:false},
                     ff:{name:"",p:false,o:false},
                    mmm:{name:"",p:false,o:false},
                    mmf:{name:"",p:false,o:false},
                    mfm:{name:"",p:false,o:false},
                    mff:{name:"",p:false,o:false},
                    fmm:{name:"",p:false,o:false},
                    fmf:{name:"",p:false,o:false},
                    ffm:{name:"",p:false,o:false},
                    fff:{name:"",p:false,o:false}
                },
                upload: undefined,
                pgfirstnames:"",
                pglastname:"",
                pgmobilephone:"",
                pgemail:"",
                history:false,
                classical:false,
                geography:false,
                art_history:false,
                calculus:false,
                statistics:false,
                science:false
            }
        }
    },
    props: ['tabstr'],
    methods: {
        applicantEligable: function(){
            return (this.rec.secondarystudent=='Yes'&&((this.rec.descendant=='Yes')||this.rec.descendant=='Unsure'));
        },
        clickTab: function(e){
            if (e.type=="keydown")
                if (e.keyCode!=32)
                    return;
            let newi = e.target.dataset.i;
            //if (newi > 1 && this.rec.secondarystudent!="Yes")
            if (newi > 1 && !this.applicantEligable())
                return;
            this.checkAllGood();
            this.selected_tab = newi;
        },
        checkAllGood: function() {
            // get a list of all the refs that have an allGood function, call each one and update 'done'
            let refs = this.$parent.$refs;
            let ra = Object.keys(refs);
            this.incompleteTabs = [];
            for (let ref=undefined, i=0; ref=ra[i]; i++)// eslint-disable-line
            {
                if (!refs[ref].allGood)
                    continue;
                let tabnum = ref.slice(1); 
                let valid = refs[ref].allGood();
                // now get correct tab and set it to done
                let k = "S"+tabnum;
                let tabObject = this.tabNames.find(u=>u.name==k);
                if (tabObject){
                    tabObject.done = valid;
                    if (!valid)
                        this.incompleteTabs.push(tabnum);
                }
            }
        },
        nextTab: function(){
            this.checkAllGood();
            if (this.selected_tab<(this.tabNames.length-1))
                this.selected_tab++;
        },
        prevTab: function(){
            this.checkAllGood();
            this.selected_tab--;
        },
        sanitize: function(s){
            let rv=s;
            if (typeof(s)=="string" && s.length){
                const dp = new DOMParser();
                let d = dp.parseFromString(s,'text/html');
                rv = d.firstChild.textContent;
            }
            return rv;
        },
        submit: async function(){
            // post our carefully collected data to whatever
            let fd = new FormData();
            debugger;//eslint-disable-line
            for (const prop in this.rec){
                switch (prop) {
                    case "Ancestor":
                        for (const ob in this.rec.Ancestor){
                            fd.append(ob, this.sanitize(this.rec.Ancestor[ob].name));
                            if (this.rec.Ancestor[ob].p)
                                fd.append("p"+ob, "true");
                            if (this.rec.Ancestor[ob].o)
                                fd.append("o"+ob, "true");
                        }
                        break;
                    case "upload":
                        // handled elsewhere?
                        break;
                    default:
                        fd.append(prop, this.sanitize(this.rec[prop]));
                }
            }
            if (this.rec.upload){
                Array.from(this.rec.upload).forEach(function (u,i){
                    fd.append("file" + i, u);
                });
            }
            try {
                let resp = await fetch("form-sub.ashx", {body: fd, method:"post"});
                if (resp.ok){
                    let json = await resp.json();
                    if (json.status=="ok"){
                        this.$parent.submittedOk = true;    
                    } else {
                        this.$parent.submissionError = "json error";
                    }
                } else {
                    this.$parent.submissionError = resp.status;
                }
            } catch(ex) {
                this.$parent.submissionError = ex;
            }
        }
    },
    mounted: function(){
        this.tabNames = this.tabstr.split(",").map(function(u){ return {name:u, done:false}});
        this.tabNames[0].done = true;
    }/*,
    created: function(){
        EventBus.$on("set_tab",(idx)=>{this.selected_tab=idx});
    }*/
}
</script>

<style>
    .tab_wrap {
        max-width: 1400px;
        margin: 0 auto;
    }
    .tab_bar>span.done::after {
        border-left-color: var(--color-secondary);
    }
    .tab_bar>span.selected::after {
        border-left-color: var(--color-primary);
    }
    .tab_bar>span.selected, .tab_bar>span.done {
        background: var(--color-secondary);
        color:white;
    }
    .tab_bar>span.selected {
        background: var(--color-primary);
    }
    .tab_bar {
        display: flex;
        font-weight: 600;
        position: relative;
        justify-content: center;
    }
    .tab_bar>span::before {
        content:"";
        position: absolute;
        pointer-events: none;
        border: solid transparent;
        border-width: 0.75em 0;
        border-left-color:white;
        border-left-width: 6px;
        top:0;
        right: -10px;
    }
    .tab_bar>span::after {
        content:"";
        pointer-events: none;
        position: absolute;
        border: solid transparent;
        border-width: 0.75em 0;
        border-left-color: var(--color-light-1);
        border-left-width: 6px;
        top:0;
        right:-6px;
    }
    .tab_bar>span:last-of-type {
        border-right: 8px solid var(--color-light-1);
    }
    .tab_bar>span.selected:last-of-type,
    .tab_bar>span.done:last-of-type {
        border-right: 8px solid var(--color-secondary);
    }
    .tab_bar>span.selected:last-of-type{
        border-right: 8px solid var(--color-primary);
    }
    .tab_bar>span:last-of-type::after,
    .tab_bar>span:last-of-type::before {
        border-left-color: transparent;
    }
    .tab_bar>span:nth-child(2) {
        z-index: 500;
    }
    .tab_bar>span:nth-child(3) {
        z-index: 400;
    }
    .tab_bar>span:nth-child(4) {
        z-index: 300;
    }
    .tab_bar>span:nth-child(5) {
        z-index: 200;
    }
    .tab_bar>span:nth-child(6) {
        z-index: 100;
    }
    .tab_bar>span:nth-child(1) {
        z-index: 600;
        margin-left:0;
        padding-left: 30px;
    }
    .tab_bar>span {
        box-sizing: border-box;
        padding: 2px 14px;
        max-width: 130px;
        font-size: 1.3rem;
        /* font-weight: bold; */
        outline: none;
        margin-left: 4px;
        background: var(--color-light-1);
        overflow: visible;
        position: relative;
    }
    .tab_bar>span:not(:first-child)::first-letter {
        color:transparent;
    }
    .tab_wrap>.tab:not(.selected){
        display: none;
    }
</style>